import React, { Component } from 'react'

import _ from "lodash";
import moment from "moment";

import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from 'actions';


// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// material ui
import GridList from '@material-ui/core/GridList';
import Icon from '@material-ui/core/Icon';

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Paper from '@material-ui/core/Paper';
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from 'components/CustomInput/CustomInput';

import Modal from "react-modal";

// styles
import {
  blackColor,
  kakaoColor,
  grayColor,
  hexToRgb
} from "assets/jss/material-dashboard-pro-react.jsx";
import Quote from 'components/Typography/Quote';
import NavPills from 'components/NavPills/NavPills';
import defaultAvatar from "assets/img/placeholder.jpg";
import { red } from '@material-ui/core/colors';
import { createMessageGroup } from 'db';

const styles = {
  gridListMessageGroup: {
    flexDirection: 'row',
    justifyContents: 'flex-start',
    alignItems: 'flex-start',
    height: '700px',
  },
  groupDiv: {
    // height: "130px",
    margin: "10px 10px 0px 0px",
    padding: "10px",
    borderRadius: "10px",
    border: "1px solid",
    borderColor: grayColor[10],
    backgroundColor:
      "rgba(" +
      hexToRgb(grayColor[10]) +
      ", 0.6)",
  },
  gridListMessages: {
    flexDirection: 'row',
    justifyContents: 'flex-end',
    alignItems: 'flex-end',
    height: '700px',
    // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
    // transform: 'translateZ(0)',
  },
  messageGridItem: {
    // backgroundColor: 'blue',
  },
  messageDivMe: {
    // height: "130px",
    margin: "10px 10px 0px 40%",
    padding: "10px",
    borderRadius: "10px",
    border: "1px solid",
    borderColor: kakaoColor,
    backgroundColor:
      "rgba(" +
      hexToRgb(kakaoColor) +
      ", 1.0)",
  },
  messageDivOthers: {
    margin: "10px 40% 0px 0px",
    borderColor: "white",
    backgroundColor:
      "rgba(" +
      hexToRgb("#ffffff") +
      ", 1.0)",
  },
  profileImage: {
    maxWidth: "32px",
    maxHeight: "32px",
    // margin: "-50px auto 0",
    borderRadius: "50%",
    overflow: "hidden",
    padding: "0",
    // boxShadow:
    //   "0 16px 38px -12px rgba(" +
    //   hexToRgb(blackColor) +
    //   ", 0.56), 0 4px 25px 0px rgba(" +
    //   hexToRgb(blackColor) +
    //   ", 0.12), 0 8px 10px -5px rgba(" +
    //   hexToRgb(blackColor) +
    //   ", 0.2)",
    "&$cardAvatarPlain": {
      marginTop: "0"
    }
  },
  marginRight: {
    marginRight: "5px"
  },
  icons: {
    // width: "20px",
    // height: "20px"
  },
  circleButton: {
    width: "20px",
    height: "40px"
  },
  gridPadding8px: {
    padding: "0 8px !important"
  },
  padding8px: {
    padding: "0 26px !important"
  },
};

const modalCustomStyles = {
  content: {
    padding: "3%",
    top: '10%',
    left: '30%',
    right: '30%',
    bottom: '10%',
    backgroundColor: 'white',
    borderWidth: '0px',
    // marginRight: '-20%',
    // transform: 'translate(-20%, -20%)',
  },
  overlay: {
    zIndex: 10,
    backgroundColor: 'rgba(128, 128, 128, 0.4)',
  }
};

const HEADER_MARGIN = 300;

class MessageGroups extends Component {

  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: false,
      newMessage: {
        content: "",
        author: {
          user_id: null,
          profile_image_url: null,
          name: null,
        }
      },
      currentMessageGroupId: null,
      selectedUsers: [],
    }
    this.messageUnsubscribes = {};
    this.debouncedSubmitMessage = _.debounce(this.submitMessage, 1000, { maxWait: 1000, leading: true, trailing: false });
  }

  updateWindowDimensions = () => {
    console.log("updateWindowDimenstions: ", window.innerWidth, window.innerHeight);
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  componentDidMount() {
    Modal.setAppElement('#root');

    if (!this.props.orgs) {
      this.props.getOrgsAction();
    }

    const { uid } = this.props.currentUser;
    if (this.messageGroupUnsubscribe) {
      this.messageGroupUnsubscribe();
    }
    this.messageGroupUnsubscribe = this.props.getMessageGroupsAction(uid);

    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    if (this.messageGroupUnsubscribe) {
      this.messageGroupUnsubscribe();
    }
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  onChange = e => {
    const { newMessage } = this.state;
    newMessage.content = e.target.value;
    this.setState({ newMessage });
  }

  handleKeyDown = e => {
    if (!e.ctrlKey && e.key === "Enter") {
      e.preventDefault();
      this.debouncedSubmitMessage();
      return false;
    }
    if (e.ctrlKey && e.key === "Enter") {
      const { newMessage } = this.state;
      this.setState({ newMessage: `${newMessage}\n` });
      e.preventDefault();
      return false;
    }
  }

  submitMessage = () => {
    const { currentMessageGroupId, newMessage } = this.state;
    const { currentUser } = this.props;

    newMessage.author = {
      user_id: currentUser.uid,
      name: currentUser.displayName,
      profile_image_url: currentUser.photoURL
    };

    if (currentMessageGroupId && newMessage.content.length > 0) {
      this.props.saveMessageAction(currentMessageGroupId, null, newMessage)
        .then(() => {
          console.log('this.state.newMessage: ', this.state.newMessage);
          this.setState({
            newMessage: {
              content: "",
              author: {
                user_id: null,
                profile_image_url: null,
                name: null,
              }
            }
          }, () => console.log('this.state.newMessage: ', this.state.newMessage));
        });
    }
  }

  renderMessageGroups = () => {
    const { messages } = this.props;

    const { height } = this.state;

    return <GridContainer direction="column">
      <GridContainer justify="space-between" alignItems="center" style={{
        padding: '20px',
      }}>
        <GridItem><h3>대화 목록</h3></GridItem>
        <GridItem>
          <Button color="primary" round style={styles.marginRight} onClick={this.openModal}>
            <Icon style={styles.icons}>add</Icon>
          </Button>
        </GridItem>
      </GridContainer>
      <GridList style={{ ...styles.gridListMessageGroup, height: this.state.height - HEADER_MARGIN }} cols={1} cellHeight="auto">
        {
          this.props.messageGroups
            .map(group => <GridItem key={group.id}
              onClick={() => {
                if (this.state.currentMessageGroupId === group.id) {
                  return; // do nothing
                }
                const last_message = _.last(messages[group.id]);
                if (this.messageUnsubscribes[group.id]) {
                  this.messageUnsubscribes[group.id]();
                }
                this.setState({ currentMessageGroupId: group.id }, () => {
                  this.messageUnsubscribes[group.id] = this.props.getMessagesAction(group.id, last_message);
                });
              }}
            >
              <div style={styles.groupDiv}>
                <GridContainer direction="column">
                  <GridItem>
                    {group.data().last_message}
                  </GridItem>
                  <GridItem>
                    {
                      group.data().updated_at
                        ? moment(group.data().updated_at.toDate()).format('ll')
                        : null
                    }
                  </GridItem>
                </GridContainer>
              </div>
            </GridItem>)
        }
      </GridList>
    </GridContainer>
  }

  renderMessages = (messageGroupId) => {

    if (!messageGroupId) {
      return;
    }

    const { newMessage } = this.state;
    const { currentUser, messages, classes } = this.props;
    const currentGroupMessages = messages[messageGroupId] || [];


    return <GridContainer direction="column" spacing={2}>
      <GridContainer direction="column" style={{
        backgroundColor: "#bed1db",
        borderColor: grayColor[1],
        padding: "20px"
      }}>
        <GridList
          style={{ ...styles.gridListMessages, height: this.state.height - HEADER_MARGIN }}
          cols={1}
          cellHeight="auto"
          ref={el => {
            if (el) {
              console.log("scroll 시도");
              el.scrollTop = el.scrollHeight;
            } else {
              console.log("no messageList");
            }
          }}
        >
          {
            currentGroupMessages.map(message => {
              const data = message.data();
              return data.author.user_id === currentUser.uid
                ? <GridItem style={styles.messageGridItem} key={message.id}>
                  <div style={styles.messageDivMe}>
                    <p>
                      {data.content.split("\n").map((item, idx) => <span
                        key={idx}>
                        {item}
                        <br />
                      </span>)}
                    </p>
                  </div>
                </GridItem>
                : <GridItem key={message.id}>
                  <GridContainer direction="row">
                    <GridItem className={classes.gridPadding8px}>
                      <img
                        alt="profile"
                        style={styles.profileImage}
                        src={data.author.profile_image_url}
                      />
                    </GridItem>
                    <GridItem className={classes.gridPadding8px} style={{ flexGrow: 1 }}>
                      <GridContainer direction="column" style={styles.gridPadding8px}>
                        <GridItem className={classes.gridPadding8px}>{data.author.name}</GridItem>
                        <GridItem className={classes.gridPadding8px}>
                          <div style={
                            { ...styles.messageDivMe, ...styles.messageDivOthers }
                          }>
                            <p>
                              {data.content.split("\n").map((item, idx) => <span
                                key={idx}>
                                {item}
                                <br />
                              </span>)}
                            </p>
                          </div>
                        </GridItem>
                      </GridContainer>
                    </GridItem>
                  </GridContainer>
                </GridItem>
            })
          }
        </GridList>
      </GridContainer>
      <GridContainer style={{ flexGrow: 1, justifyContents: 'center', alignItems: 'center', padding: "0 0 0 20px" }}>
        <GridItem>
          <Button color="primary" size="sm" style={styles.circleButton}>
            <Icon style={{ width: "20px", height: "20px" }}>insert_photo</Icon>
          </Button>
        </GridItem>
        <GridItem style={{ flexGrow: 1, padding: "0 10px 0 10px" }}>
          <CustomInput
            // success={_.get(valueState, `${aNewId}State`) === "success"}
            // error={_.get(valueState, `${aNewId}State`) === "error"}
            labelText={
              <span>
                새 메시지
              {/* <small>
                {question.required ? ' (필수)' : ''}
              </small> */}
              </span>
            }
            id="newMessage"
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              onChange: this.onChange,
              onKeyDown: this.handleKeyDown,
              multiline: true,
              rows: 1,
              rowsMax: 3,
              value: newMessage.content
            }}
          />
        </GridItem>
        <GridItem style={{
          marginRight: "30px"
        }}>
          <Button
            color="primary"
            round
            style={styles.marginRight}
            onClick={this.debouncedSubmitMessage}
          >
            보내기
          </Button>
        </GridItem>
      </GridContainer>
    </GridContainer>
  }

  openModal = () => this.setState({ modalIsOpen: true });
  closeModal = () => this.setState({ modalIsOpen: false });
  requestClose = () => {
    console.log("closed!");
    this.closeModal();
  }
  afterOpenModal = () => {
    if (!this.props.messageUserGroups) {
      this.props.getMessageUsersAction();
    }
  }

  toggleSelectUser = (user) => {
    const { selectedUsers = [] } = this.state;
    if (_.find(selectedUsers, { uid: user.uid })) {
      // remove from selectedUsers
      const newList = selectedUsers.filter(u => u.uid !== user.uid);
      this.setState({ selectedUsers: newList });
    } else {
      // add to selectedUsers
      this.setState({ selectedUsers: [...selectedUsers, user] });
    }
  }

  renderUserList = (users) => {
    const { selectedUsers = [] } = this.state;

    return <GridList style={{ height: this.state.height - HEADER_MARGIN * 2 }} cols={1} cellHeight="auto">

      {
        users
          .filter(user => user.uid !== this.props.currentUser.uid)
          .map(user =>
            <GridContainer
              key={user.uid}
              spacing={2}
              alignItems="center"
              onClick={() => this.toggleSelectUser(user)}
            >
              <GridItem>
                <img
                  alt="profile"
                  style={styles.profileImage}
                  src={user.profile_image_url
                    ? /^http/.test(user.profile_image_url)
                      ? user.profile_image_url
                      : defaultAvatar
                    : defaultAvatar} />
              </GridItem>
              <GridItem>
                {user.name}
              </GridItem>
              <GridItem>
                {
                  _.find(selectedUsers, { uid: user.uid })
                    ? <Icon fontSize={"small"} color={"inherit"}>checked</Icon>
                    : null
                }
              </GridItem>
            </GridContainer>
          )
      }
    </GridList>
  }

  startChat = () => {
    const { selectedUsers } = this.state;
    const { currentUser } = this.props;
    const { uid, photoURL: profile_image_url, displayName: name } = currentUser;

    selectedUsers.push({ uid, profile_image_url, name });

    createMessageGroup(selectedUsers)
      .then(() => {
        this.setState({ selectedUsers: [], modalIsOpen: false });
        this.props.showAlertAction({
          message: `대화방이 생성되었습니다.`,
          color: 'danger',
        })
      })
      .catch(e => console.error('실패', e));
  }

  renderModal = () => {
    return <Modal
      isOpen={this.state.modalIsOpen}
      onAfterOpen={this.afterOpenModal}
      onRequestClose={this.requestClose}
      style={modalCustomStyles}
      contentLabel="유저 선택"
    >
      <GridContainer justify="center">
        <h4>대화 상대를 선택해주세요</h4>
      </GridContainer>
      <NavPills
        color="info"
        alignCenter
        tabs={
          this.props.messageUserGroups
            ? this.props.messageUserGroups
              .map(group => ({ tabButton: group.title, tabContent: this.renderUserList(group.users) }))
            : []
        }
      />
      <GridContainer justify="center" style={{ marginTop: "20px" }}>
        <GridItem>
          <Button
            color="primary"
            disabled={this.state.selectedUsers.length === 0}
            onClick={this.startChat}
          >
            이야기 나누기
          </Button>
        </GridItem>
      </GridContainer>

    </Modal>
  }

  render() {
    const { currentMessageGroupId = null } = this.state;
    const { classes } = this.props;
    return (
      <GridContainer style={{
        flexGrow: 1, border: "1px solid lightgray"
      }} spacing={2}>
        {/* < GridItem xs={4} style={{
          backgroundColor: 'white',
          borderRight: "0.5rem solid lightgray",
        }
        }>
          {this.renderMessageGroups()}
        </GridItem > */}
        <GridItem>
          {this.renderMessages(currentMessageGroupId)}
        </GridItem>
        {this.renderModal()}
      </GridContainer >
    )
  }
}

const mapStateToProps = (state) => {
  return {
    orgs: state.org.orgs,
    currentUser: state.auth.currentUser,
    messageGroups: state.message.groups,
    messages: state.message.messages,
    messageUserGroups: state.message.messageUserGroups,
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(actions, dispatch);
}

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(MessageGroups);